import { useState, useEffect } from 'react'

const {
    REACT_APP_FIREBASE_PROJECT_ID,
} = process.env

const useCertificate = (cid = '', date = '') => {
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)
    const [data, setData] = useState({})

    useEffect(() => {
        const url = `https://us-central1-${REACT_APP_FIREBASE_PROJECT_ID}.cloudfunctions.net/getCertificateInfo?date=${date}&cid=${cid}`

        fetch(url)
            .then((res) => {
                if (!res.ok) {
                    throw new Error('Couldn\'t load certificate')
                }

                return res.json() // Promise
            })
            .then((json) => {
                setData({ cid, ...json })
                setLoading(false)
            })
            .catch((e) => {
                console.log(`Error when fetching certificate ${cid} - ${e}`)
                setLoading(false)
                setError(e)
            })

    }, [cid, date])

    return [loading, error, data]
}

export default useCertificate
